import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

function OrderResult() {
    const [title, setTitle] = useState()
    const [message, setMessage] = useState()
    const { status } = useParams();

    const history = useNavigate()
    const isFinalPaymentStatus = status === 'success' || status === 'error'

    const handleOpenTransactionList = () => {
        history('/transaction/list', { replace: isFinalPaymentStatus })
    }

    useEffect(() => {
        switch (status) {
            case "nopay":
                setTitle("Ops....")
                setMessage('Anda belum melakukan pembayaran, silahkan pilih tombol "lanjutkan pembayaran" di daftar tansaksi ada untuk menyelesaikan transaksi anda')
                break;
            case "success":
                setTitle("Selamat...!")
                setMessage('Transaksi anda berhasil, silahkan lihat daftar transaksi anda')
                break;
            case "error":
                setTitle("Ops...!")
                setMessage('Terjadi kesalahan pada pembayaran anda, silahkan cek di daftar transaksi')
                break;
            case "pending":
                setTitle("Terima kasih...")
                setMessage('Kami menunggu konfirmasi dari pembayaran anda dari pihak bank, silahkan cek di daftar transaksi anda')
                break;
            default:
                break;
        }
    }, [status])

    return (
        <div className="h-screen w-full">
            <div className="h-screen container mx-auto p-5 pt-20 pb-24  overflow-auto no-scrollbar flex justify-center items-center">
                <div className='w-3/4 border rounded-md h-1/2 flex flex-col items-center justify-center p-5'>
                    <div className='text-2xl font-bold mb-5'>{title}</div>
                    <div className='text-md text-center mb-5'>{message}</div>
                    <button className='btn' onClick={handleOpenTransactionList}>Lihat Daftar Transaksi</button>
                </div>
            </div>
        </div>
    )
}

export default OrderResult
